import { useState } from 'react';

/**
 * Hook returning transition event props that can be spread on a transition component to access the
 * current transition state.
 *
 * @param defaultState - The default state to use.
 */ function useTransitionState(defaultState = 'hidden') {
    const [animationState, setAnimationState] = useState(defaultState);
    return [
        animationState,
        {
            onEntering: ()=>setAnimationState('entering'),
            onEntered: ()=>setAnimationState('visible'),
            onExiting: ()=>setAnimationState('exiting'),
            onExited: ()=>setAnimationState('hidden')
        }
    ];
}

export { useTransitionState };
//# sourceMappingURL=use-transition-state.js.map
